import * as React from 'react';
import * as acl from 'common/utils/acl';

import { AddressBlock } from 'common/components/AddressBlock';
import { AppState } from 'common/models/AppState';
import { Datetime } from 'common/components/Datetime';
import { EditableTags } from 'common/components/EditableTags';
import { Email } from 'common/components/Email';
import { Phone } from 'common/components/Phone';
import { SocialLinks } from 'common/components/SocialLinks';
import { MemberLink } from 'common/components/link/MemberLink';
import { UserPermissions } from 'common/api/models/UserPermissions';
import { formatRevenueRange } from 'common/utils/format';
import { Member } from 'common/api/models/Member';
import { Tag } from 'common/api/models/Tag';
import { CONTACT_TYPES } from 'common/constants';

export interface OrgsDetailInfoProps {
  org: Member;
  subOrgs: Member[];
  member?: Member;
  appState: AppState;
  onUpdateTags: (tagIds: string[]) => void;
  onUpdateInternalTags: (tagIds: string[]) => void;
}

export class OrgsDetailInfo extends React.Component<OrgsDetailInfoProps> {
  render() {
    const org = this.props.org;
    const entities = this.props.appState.entities;
    const member = this.props.member;
    const profileUrl = member && member.slug ? process.env.REACT_APP_WEB_URL + '/' + member.slug! : undefined;
    const subOrgs = this.props.subOrgs;
    // console.log(org);
    // console.log(entities);
    return (
      <div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-2 text-right">
            <b>Created</b>
          </div>
          <div className="col">
            <Datetime at={org.createAt} /> by <MemberLink member={entities.member[org.createId!]} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Updated</b>
          </div>
          <div className="col">
            <Datetime at={org.updateAt} /> by <MemberLink member={entities.member[org.updateId!]} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>NKBA Profile</b>
          </div>
          <div className="col">
            {profileUrl && (
              <a href={profileUrl} target="_blank">
                {profileUrl}
              </a>
            )}
            {!profileUrl && <span>None</span>}
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Member Type</b>
          </div>
          <div className="col">
            {member && member.memberType}
            {!member && 'Non Member'}
          </div>
        </div>
        {member && (
          <div className="row">
            <div className="col-2 text-right">
              <b>Paid Branches</b>
            </div>
            <div className="col">
              {member.paidBranchCount} ({member.branchCount} in use)
            </div>
          </div>
        )}
        {member &&
          !!member.indBranchCount && (
            <div className="row">
              <div className="col-2 text-right">
                <b>Indep. Branches</b>
              </div>
              <div className="col">{member.indBranchCount}</div>
            </div>
          )}
        {member && (
          <div className="row">
            <div className="col-2 text-right">
              <b>Renewal Date</b>
            </div>
            <div className="col">
              <Datetime at={member.expireDate} format="MMMM D, YYYY" />
            </div>
          </div>
        )}
        {member && (
          <div className="row">
            <div className="col-2 text-right">
              <b>Renewal Type</b>
            </div>
            <div className="col">
              {member.renewType && member.renewType === Member.RenewType.AUTO
                ? 'Auto-Renew'
                : member.renewType && member.renewType === Member.RenewType.MANUAL
                  ? 'Manual'
                  : 'Invoice'}
            </div>
          </div>
        )}
        {member &&
          member.contacts &&
          CONTACT_TYPES.filter(c => member!!.contacts!![c.value]).map(c => (
            <div key={c.value} className="row">
              <div className="col-2 text-right">
                <b>{c.label} Contact</b>
              </div>
              <div className="col">
                {' '}
                <MemberLink member={entities.member[member!!.contacts!![c.value]]} />
              </div>
            </div>
          ))}
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-2 text-right">
            <b>Social Profiles</b>
          </div>
          <div className="col">{member ? <SocialLinks social={member.social} /> : <span>None</span>}</div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Email</b>
          </div>
          <div className="col">
            <Email email={org.email!} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Phone</b>
          </div>
          <div className="col">
            <Phone phone={org.workPhone!} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Website</b>
          </div>
          <div className="col">{member ? member.website : 'None'}</div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Work Address</b>
          </div>
          <div className="col">
            <AddressBlock address={org.workAddress!} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Mailing Address</b>
          </div>
          <div className="col">
            <AddressBlock address={org.shippingAddress!} />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Billing Address</b>
          </div>
          <div className="col">
            <AddressBlock address={org.billingAddress!} />
          </div>
        </div>

        {!org.parentOrgId && (
          <div className="row">
            <div className="col-2 text-right">
              <b>Revenue</b>
            </div>
            <div className="col">{formatRevenueRange(Number(org.revenueRange))}</div>
          </div>
        )}
        <div className="row">
          <div className="col-2 text-right">
            <b>Join Date</b>
          </div>
          <div className="col">
            <Datetime at={org.joinDate} format="MMMM D, YYYY" />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Segment</b>
          </div>
          <div className="col">
            {org.segment && org.segment === 'BUILDING'
              ? 'Building and/or Remodeling'
              : org.segment && org.segment === 'COLLEGE'
                ? 'College / University'
                : org.segment && org.segment === 'CABINET'
                  ? 'Cabinet Shop'
                  : org.segment && org.segment === 'DEALER'
                    ? 'Dealer / Showroom'
                    : org.segment && org.segment === 'DESIGN'
                      ? 'Design'
                      : org.segment && org.segment === 'IP'
                        ? 'Industry Partner'
                        : org.segment && org.segment === 'MANUFACTURING'
                          ? 'Manufacturing'
                          : org.segment && org.segment === 'RETAIL'
                            ? 'Retail'
                            : org.segment && org.segment === 'SKILLED'
                              ? 'Skilled Trades'
                              : org.segment && org.segment === 'WHOLESALE'
                                ? 'Wholesale'
                                : org.segment && 'Other'}
            {!org.segment && 'No Segment Assigned'}
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Featured Jobs</b>
          </div>
          <div className="col">
            <span>{org.jobsFeatured === true ? 'Yes' : 'No'}</span>
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Chapter</b>
          </div>
          <div className="col">
            {org.chapterId && entities.chapter[org.chapterId] && entities.chapter[org.chapterId].name}
            {!org.chapterId && 'None/Foreign'}
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Tags</b>
          </div>
          <div className="col-8">
            <EditableTags
              tagIds={org.tagIds!}
              tags={this.props.appState.entities.tag}
              onSave={this.props.onUpdateTags}
              canEdit={acl.hasPermission(this.props.appState, UserPermissions.Permissions.EDIT_MEMBER_TAGS)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-2 text-right">
            <b>Internal Tags</b>
          </div>
          <div className="col-8">
            <EditableTags
              tagIds={org.internalTagIds!}
              type={Tag.Type.INTERNAL}
              tags={this.props.appState.entities.tag}
              onSave={this.props.onUpdateInternalTags}
              canEdit={acl.hasPermission(this.props.appState, UserPermissions.Permissions.EDIT_MEMBER_TAGS)}
            />
          </div>
        </div>
        {subOrgs.length > 0 && (
          <div className="row" style={{ marginTop: 20 }}>
            <div className="col-2 text-right">
              <b>Branches</b>
            </div>
            <div className="col-10">
              {subOrgs.map(o => (
                <div key={o.id}>
                  <b>
                    <MemberLink member={o} />
                  </b>{' '}
                  {o.workAddress && (
                    <span>
                      ({o.workAddress.city}, {o.workAddress.state})
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div className="col" />
          </div>
        )}
        {member &&
          member.memberType &&
          member.memberType === Member.MemberType.SCHOOL && (
            <>
              <div className="row">
                <div className="col-2 text-right">
                  <b>Founding School</b>
                </div>
                <div className="col">
                  {org.foundingSchool && 'Yes'}
                  {!org.foundingSchool && 'No'}
                </div>
              </div>
              <div className="row">
                <div className="col-2 text-right">
                  <b>Programs</b>
                </div>
                <div className="col">
                  {org.programsOffered && org.programsOffered.length > 0 && org.programsOffered.join(', ')}
                  {(!org.programsOffered || org.programsOffered.length === 0) && 'None'}
                </div>
              </div>
              <div className="row">
                <div className="col-2 text-right">
                  <b>Program Type</b>
                </div>
                <div className="col">
                  {org.programType}
                  {!org.programType && 'None'}
                </div>
              </div>
              <div className="row">
                <div className="col-2 text-right">
                  <b>Web Address</b>
                </div>
                <div className="col">
                  {org.programsWebAddress}
                  {!org.programsWebAddress && 'None'}
                </div>
              </div>
              <div className="row">
                <div className="col-2 text-right">
                  <b>Degrees Offered</b>
                </div>
                <div className="col">
                  {org.degreesOffered && org.degreesOffered.length > 0 && org.degreesOffered.join(', ')}
                  {(!org.degreesOffered || org.degreesOffered.length === 0) && 'None'}
                </div>
              </div>
              <div className="row">
                <div className="col-2 text-right">
                  <b>AKBD Approved</b>
                </div>
                <div className="col">
                  {org.akbdApproved && 'Yes'}
                  {!org.akbdApproved && 'No'}
                </div>
              </div>
            </>
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orgs/OrgsDetailInfo.tsx